import * as React from 'react';
import { PropsWithChildren } from 'react';

import { Text, TextTag, TokenTextAppearance, TokenTextColor } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const TextWrapper: React.FC<PropsWithChildren<NonNullable<unknown>>> = ({ children }) => {
	return (
		<Wrapper appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary} tag={TextTag.div}>
			{children}
		</Wrapper>
	);
};

const Wrapper = styled(Text)`
	display: flex;
	align-items: center;
`;
